import { render } from "./AssistSelector.vue?vue&type=template&id=7ee9d6c4&ts=true"
import script from "./AssistSelector.vue?vue&type=script&lang=ts"
export * from "./AssistSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__